



















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { add, bignumber } from 'mathjs'

@Component({})
export default class MediateCostTable extends Vue {
	private columns: any = [
		{
			title: '序号',
			dataIndex: 'index',
			key: 'index',
			customRender: (text: any, record: any, index: any) => {
				if (index < this.costTableInfo[this.index].length - 1) return index + 1
			},
		},
		{
			title: '费用项',
			dataIndex: 'costName',
			key: 'costName',
			scopedSlots: { customRender: 'grayRender' },
		},
		{
			title: '任务金额',
			dataIndex: 'targetCost',
			key: 'targetCost',
			scopedSlots: { customRender: 'grayRender' },
		},
		{
			title: '实际调解金额',
			dataIndex: 'actualCost',
			key: 'actualCost',
			scopedSlots: { customRender: 'grayRender' },
			// customRender: (text, record, index) => {
			// 	console.log('text: ', text)
			// 	console.log('record: ', record, index)
			// 	if (text && Number(text) < Number(record.targetCost)) {
			// 		return {
			// 			children: <span >{text}</span>
			// 		}
			// 	}

			// 	return {
			// 		children: <span >{text}</span>
			// 	}
			// }
		},
		{
			title: '',
			dataIndex: 'diff',
			key: 'diff',
			scopedSlots: { customRender: 'redRender' },
		},
	]

	@Prop()
	private costTableInfo!: any

	@Prop()
	private index!: number
}
